import { render, staticRenderFns } from "./ProjectNotesModal.vue?vue&type=template&id=6a2dc27c&scoped=true&"
import script from "./ProjectNotesModal.vue?vue&type=script&lang=js&"
export * from "./ProjectNotesModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectNotesModal.vue?vue&type=style&index=0&id=6a2dc27c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2dc27c",
  null
  
)

export default component.exports